module.exports = __webpack_public_path__ + "static/media/logo256.4a192eb4.png";